/**
 * @file プロバイダー（事業者）情報を管理するステート
 *
 * FVNOマイページは複数の事業者（SNCC, 各種FVNO）で共用されるため、
 * 事業者ごとのサービス名・会社名・規約URL・サポートデスク情報等を保持する。
 * providerConfigフックで設定され、サイト全体のブランディングやリンク先の切り替えに使用される。
 * セッションストレージに永続化される。
 */
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/** プロバイダー情報の型 */
export type ProviderInfoStateType = {
  /** 事業者ID（例: 'sncc', '11fv'等） */
  providerId: string;
  /** サービス名称 */
  serviceName: string;
  /** 会社名 */
  companyName: string;
  /** ページタイトル */
  pageTitle: string;
  /** meta description */
  metaDiscription: string;
  /** meta keywords */
  metaKeywords: string;
  /** サービスURL */
  serviceUrl: string;
  /** 料金プラン規約URL */
  planKiyakuUrl: string;
  /** オプション規約URL */
  optionKiyakuUrl: string;
  /** オプション詳細URL */
  optionDetailUrl: string;
  /** 決済ロゴファイル名 */
  settleLogoFile: string;
  /** 重設説明URL */
  jyusetsuUrl: string;
  /** サポートデスク名 */
  supportdeskname: string;
  /** サポートデスク電話番号 */
  supportdesktel: string;
  /** サポートデスク受付時間 */
  supportdeskemploymenttime: string;
  /** サポートデスク営業日 */
  supportdeskemploymentday: string;
};

export const providerInfoState = atom<ProviderInfoStateType>({
  key: 'providerInfoState',
  default: {
    providerId: '',
    serviceName: '',
    companyName: '',
    pageTitle: '',
    metaDiscription: '',
    metaKeywords: '',
    serviceUrl: '',
    planKiyakuUrl: '',
    optionKiyakuUrl: '',
    optionDetailUrl: '',
    settleLogoFile: '',
    jyusetsuUrl: '',
    supportdeskname: '',
    supportdesktel: '',
    supportdeskemploymenttime: '',
    supportdeskemploymentday: '',
  },
  effects_UNSTABLE: [persistAtom],
});

export default providerInfoState;
